import React, { Component } from 'react';
import PageWrapper from '../../components/PageWrapper';
import { ErrorCode } from '../../constants/statusCode';
import connectPage from '../../scenes/Main/index';
import Routes from '../../constants/routes';
import MessagePanel from '../../components/MessagePanel/index';
import { ErrorMessages } from '../../constants/text';
import { 
    isPrestoApp, 
    MobileResultPath 
} from '../../constants/appState';


class Error extends Component {
    pageName;

    constructor(props) {
        super(props);

        this.pageName = Routes.ERROR;

        this.state = {
            errorTitle: '',
            errorMessage: ''
        };
    }

    componentDidMount() {
        /* 
        if(!!isPrestoApp) {
            window.location.replace(MobileResultPath + 'failed');
        } 
        */

        this.getErrorTitle();
    }

    goBackHome = () => {
        const { actionHandler } = this.props;

        actionHandler.resetAllData();
        window.location = window.history.back();
    }; 

    getErrorTitle = () => {
        const { mainProps } = this.props;
        let errorTitle = '', errorMessage = '';
        
        switch(+mainProps.errorCode) {
            case ErrorCode.HTTP_NOT_FOUND:
                errorTitle = ErrorMessages[ErrorCode.HTTP_NOT_FOUND].title; 
                errorMessage = ErrorMessages[ErrorCode.HTTP_NOT_FOUND].message;
                break;
            case ErrorCode.HTTP_BAD_REQUEST:
            default:
                errorTitle = ErrorMessages.DefaultError.title; 
                errorMessage = ErrorMessages.DefaultError.message;
                break;
        };
        
        this.setState({
            errorTitle,
            errorMessage
        });
    };

    render() {
        const { 
            errorTitle,
            errorMessage,
         } = this.state;

        return (
            <PageWrapper>
                <MessagePanel 
                    className="page-error"
                    title={errorTitle}
                    message={errorMessage}
                    isError
                />
            </PageWrapper>
        );
    }
}

export default connectPage(Error);